import React from "react";

export default function CommonSearchBar({
  containerClassName,
  label,
  type,
  id,
  name,
  placeholder,
  onChange,
  onKeyPress,
  value,
  maxLength,
  autoFocus,
  error,
  isDisabled,
  isReadOnly,
  onClickSearchButton,
}) {
  return (
    <>
      <div
        className={`myrl-input-div myrl-input-div--searchBar ${containerClassName}`}
      >
        {/* <label htmlFor={id ? id : name}>{label}</label> */}
        <form onSubmit={onClickSearchButton}>
          <div className="input-border-div">
            <img
              alt=""
              src="/img/desktop/icons/white-search-icon.svg"
              className="myrl-input-div--searchBar__searchIcon"
            />
            <input
              type={type}
              id={id ? id : name}
              name={name}
              placeholder={placeholder}
              onChange={onChange}
              value={value}
              maxLength={maxLength}
              autoComplete="off"
              autoFocus={autoFocus}
              disabled={isDisabled}
              onKeyPress={onKeyPress}
              readOnly={isReadOnly}
            />
            <button
              type="submit"
              className="login-btn login-btn--searchBar"
              onClick={onClickSearchButton}
            >
              Search
            </button>
          </div>
        </form>

        {error ? (
          <p className="error-message">{error}</p>
        ) : (
          <p className="error-message opacity-0">error</p>
        )}
      </div>
    </>
  );
}

CommonSearchBar.defaultProps = {
  type: "text",
  label: "",
  placeholder: "",
  maxLength: "",
  error: "",
  autoFocus: "",
  isDisabled: false,
  isReadOnly: false,
  onKeyPress: () => {},
};
